/* @flow */
import React, { Component } from 'react';
import { type FormProps, reduxForm, Field, SubmissionError } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';

import { sendSystemNotification } from '../../mutations';

const styles = {
  root: {
    padding: 10,
  },
};

type Props = {} & FormProps;

class Testing extends Component<Props> {
  submit = async values => {
    try {
      await sendSystemNotification(values);
    } catch (ex) {
      throw new SubmissionError(ex);
    }
  };

  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div style={styles.root}>
        <form onSubmit={handleSubmit(this.submit)}>
          <Field
            name="message"
            floatingLabelText="Message"
            multiLine
            component={TextField}
          />
          <br />
          <Field
            name="channel"
            floatingLabelText="Channel"
            component={TextField}
          />
          <br />
          <RaisedButton
            disabled={submitting}
            label="Send"
            onClick={handleSubmit(this.submit)}
            primary
          />
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'testingForm',
})(Testing);



// WEBPACK FOOTER //
// ./src/components/testing/SystemNotification.js